"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var relay_runtime_1 = require("relay-runtime");
var offline_first_1 = require("@wora/offline-first");
var resolveImmediate_1 = tslib_1.__importDefault(require("relay-runtime/lib/util/resolveImmediate"));
var uuid_1 = require("uuid");
var warning_1 = tslib_1.__importDefault(require("fbjs/lib/warning"));
var Environment = (function (_super) {
    tslib_1.__extends(Environment, _super);
    function Environment(config, persistOfflineOptions) {
        if (persistOfflineOptions === void 0) { persistOfflineOptions = {}; }
        var _this = _super.call(this, config) || this;
        _this._rehydrated = typeof window === 'undefined';
        var persistOptionsStoreOffline = tslib_1.__assign({ prefix: 'relay-offline', serialize: true }, persistOfflineOptions);
        _this._relayStoreOffline = new offline_first_1.OfflineFirst(persistOptionsStoreOffline);
        _this.setOfflineOptions();
        if (_this._rehydrated) {
            _this.promisesRestore = Promise.resolve(true);
        }
        _this._store.setCheckGC(function () { return _this.isOnline(); });
        return _this;
    }
    Environment.prototype.setOfflineOptions = function (offlineOptions) {
        var _this = this;
        if (offlineOptions === void 0) { offlineOptions = {}; }
        var onComplete = offlineOptions.onComplete, onDiscard = offlineOptions.onDiscard, network = offlineOptions.network, others = tslib_1.__rest(offlineOptions, ["onComplete", "onDiscard", "network"]);
        var options = tslib_1.__assign({ execute: function (offlineRecord) { return _this.executeStoreOffline(network, offlineRecord); } }, others);
        if (onComplete) {
            options.onComplete = function (options) {
                var offlineRecord = options.offlineRecord, response = options.response;
                var operation = offlineRecord.request.payload.operation, id = offlineRecord.id;
                var snapshot = _this.lookup(operation.fragment);
                return onComplete({ id: id, offlinePayload: offlineRecord, snapshot: snapshot.data, response: response });
            };
        }
        if (onDiscard) {
            options.onDiscard = function (options) {
                var offlineRecord = options.offlineRecord, error = options.error;
                var id = offlineRecord.id;
                return onDiscard({ id: id, offlinePayload: offlineRecord, error: error });
            };
        }
        this._relayStoreOffline.setOfflineOptions(options);
    };
    Environment.prototype.executeStoreOffline = function (network, offline) {
        if (network === void 0) { network = this.getNetwork(); }
        var payload = offline.request.payload;
        var _a = payload, operation = _a.operation, uploadables = _a.uploadables, cacheConfig = _a.cacheConfig;
        var request = operation.request ? operation.request : operation;
        var netCacheConfig = request.cacheConfig || cacheConfig || { force: true };
        netCacheConfig.metadata = tslib_1.__assign(tslib_1.__assign({}, netCacheConfig.metadata), { offline: offline });
        return network.execute(request.node.params, request.variables, netCacheConfig, uploadables).toPromise();
    };
    Environment.prototype.clearCache = function () {
        return Promise.all([this._store.purge()]).then(function (_result) {
            return true;
        });
    };
    Environment.prototype.dispose = function () {
        this.getStoreOffline().dispose();
    };
    Environment.prototype.hydrate = function () {
        var _this = this;
        if (!this.promisesRestore) {
            this.promisesRestore = Promise.all([this.getStoreOffline().hydrate(), this._store.hydrate()])
                .then(function (_result) {
                _this._rehydrated = true;
                var updateRecords = _this._store.__getUpdatedRecordIDs();
                Object.keys(_this._store.getSource().toJSON()).forEach(function (key) {
                    updateRecords.add(key);
                });
                _this._store.notify();
                return true;
            })
                .catch(function (error) {
                _this._rehydrated = false;
                throw error;
            });
        }
        return this.promisesRestore;
    };
    Environment.prototype.isRehydrated = function () {
        return this._rehydrated;
    };
    Environment.prototype.isOnline = function () {
        return this.getStoreOffline().isOnline();
    };
    Environment.prototype.getStoreOffline = function () {
        return this._relayStoreOffline;
    };
    Environment.prototype.retain = function (operation, configRetain) {
        return this._store.retain(operation, configRetain);
    };
    Environment.prototype.executeMutationOffline = function (_a) {
        var _this = this;
        var operation = _a.operation, optimisticResponse = _a.optimisticResponse, optimisticUpdater = _a.optimisticUpdater, updater = _a.updater, uploadables = _a.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) {
            optimisticConfig = {
                operation: operation,
                response: optimisticResponse,
                updater: optimisticUpdater,
            };
        }
        warning_1.default(!!optimisticConfig, 'commitMutation offline: no optimistic responses configured. the mutation will not perform any store updates.');
        var source = relay_runtime_1.Observable.create(function (sink) {
            resolveImmediate_1.default(function () {
                var sinkPublish = optimisticConfig ? _this.getStore().getSource()._sink.toJSON() : {};
                var backup = {};
                Object.keys(sinkPublish).forEach(function (key) { return (backup[key] = _this.getStore().getSource()._base.get(key)); });
                sink.next({
                    data: optimisticResponse ? optimisticResponse : {},
                });
                var id = uuid_1.v4();
                var payload = {
                    operation: operation,
                    optimisticResponse: optimisticResponse,
                    uploadables: uploadables,
                };
                var request = {
                    payload: payload,
                    backup: backup,
                    sink: sinkPublish,
                };
                _this.getStoreOffline()
                    .publish({ id: id, request: request, serial: true })
                    .then(function (_offlineRecord) {
                    _this.getStoreOffline().notify();
                    sink.complete();
                })
                    .catch(function (error) {
                    sink.error(error, true);
                });
            });
        });
        return this._execute({
            createSource: function () { return source; },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: optimisticResponse ? updater : optimisticUpdater,
        });
    };
    Environment.prototype.executeMutation = function (mutationOptions) {
        if (this.isOnline()) {
            return _super.prototype.executeMutation.call(this, mutationOptions);
        }
        else {
            return this.executeMutationOffline(mutationOptions);
        }
    };
    return Environment;
}(relay_runtime_1.Environment));
exports.Environment = Environment;
//# sourceMappingURL=Environment.js.map